// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".movie-featured__title {\n  font-size: 22px;\n  font-family: \"Roboto\", Arial, sans-serif;\n  font-weight: 300;\n  color: deeppink;\n}\n.movie-featured__title a {\n  color: inherit;\n  text-decoration: none;\n}\n.movie-featured__title small {\n  font-size: 16px;\n}\n.movie-featured__image {\n  max-width: 200px;\n  -webkit-box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.25);\n          box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.25);\n}", ""]);
// Exports
module.exports = exports;
